export const DFA_LOGO_SRC = "/dfa-logo.png";

export function programmeClassLabel(placement = {}) {
  const programme = placement.program || "Programme";
  const classArm = [placement.class_name, placement.arm].filter(Boolean).join(" ");
  return `${programme} — ${classArm || "Class not assigned"}`;
}
